import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { ImEqualizer2 } from 'react-icons/im'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import Layout from '../../../../components/layouts/Layout'
import { digitalProp } from '../slice/createEventSlice'
import DigitalProps from '../../components/Modal/DigitalProps'
import { IoTrashSharp } from 'react-icons/io5'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import { LoadingSpinner } from '../../../../components/Loader/Loader'

const DigitalSetting = () => {

    const history = useHistory();
    const dispatch = useDispatch()
    const { event_option, digital_prop, eventId } = useSelector(state => state.createEvent)
    const [emailTemplateErr, setTemplateErr] = useState(false)
    const [modalView, setModalView] = useState(false)
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)
    const [digitalPropsItem, setDigitalProps] = useState([])
    const { register, handleSubmit } = useForm()

    const handelDigitalProp = async (data) => {

        if (digitalPropsItem.length > 0) {
            await dispatch(digitalProp({ digital_prop_frame: digitalPropsItem }))
            setLoading(true)
            http.post("digital-prop", { digital_prop_frame: digitalPropsItem, eventId }).then(res => {
                if (res.data.digital_prop === 'success') {
                    setLoading(false)
                    if (event_option.water_mark             === true) { history.push('/event/custom-branding', eventId) }
                    else if (event_option.microsite         === true) { history.push('/event/microsite', eventId) }
                    else if (event_option.frame_option      === true) { history.push('/event/frame', eventId) }
                    else if (event_option.incentive_offer   === true) { history.push('/event/incentive-offer', eventId) }
                    else if (event_option.filters           === true) { history.push('/event/filter', eventId) }
                    else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                    else { history.push('/event/summary', eventId) }
                }
            }).catch(err => setLoading(false))
        }
        else {
            setTemplateErr(true)
        }
    }

    useEffect(() => {
        if (digital_prop) {
            console.log(digital_prop);
            if (digital_prop.digital_prop_frame && digital_prop.digital_prop_frame.length > 0) {
                setDigitalProps(digital_prop.digital_prop_frame)
            }
        }
    }, [digital_prop])

    const setDigitalPropsByProps = (data) => {
        setDigitalProps(data)
        setTemplateErr(false)
    }

    const removeProps = (id) => {
        let copyProps = [...digitalPropsItem]
        copyProps.splice(id, 1)
        setDigitalProps(copyProps)

    }

    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            if (digitalPropsItem.length > 0) {
                await dispatch(digitalProp({ digital_prop_frame: digitalPropsItem }))
                setDraftLoading(true)
                http.post("digital-prop", { digital_prop_frame: digitalPropsItem, eventId }).then(res => {
                    if (res.data.digital_prop === 'success') {
                        setDraftLoading(false)
                    }
                }).catch(err => setDraftLoading(false))


            }
            else {
                setTemplateErr(true)
            }

        })()
    }

    const BackToPreviousPage = (e) => {
        e.preventDefault()
               if (event_option.text_messaging === true) { history.push('/event/sms') }
          else if (event_option.email          === true) { history.push('/event/email') }
          else if (event_option.brust_gif      === true) { history.push('/event/brust-gif') }
          else if (event_option.gif            === true) { history.push('/event/gif') }
          else if (event_option.social_media   === true) { history.push('/event/social') }
          else { history.push('/event/options') }
    }

    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Digital Prop Settings</p>
                                            <p className="mb-0 text-secondary">Manage your digital props</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(handelDigitalProp)}>
                    <div className="mt-2 mb-3 row justify-content-center">
                        <div className="col-md-10">
                            <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <ImEqualizer2 size={30} />
                                        <p className="mb-0 ml-2 font-size-16">Prop Library</p>
                                    </div>
                                    <div className="float-right">
                                        <button type="button" className="mr-3 btn btn-outline-primary" onClick={() => setModalView(true)} data-toggle="modal" data-target="#digital-props-modal">Select</button>
                                        {
                                            modalView &&
                                            <DigitalProps setData={setDigitalPropsByProps} digitalPropsItem={digitalPropsItem} />
                                        }
                                    </div>
                                </div>
                                {
                                    emailTemplateErr &&
                                    <p className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${emailTemplateErr ? 'show' : 'hide'}`}>Choose any library</p>

                                }
                                <div className="prop__area">
                                    <div className="flex-wrap props-list d-flex">
                                        {
                                            digitalPropsItem.length > 0 ?
                                                digitalPropsItem.map((propItem, index) => (
                                                    <div className="prop__item" key={`digital-props-index-${index}`}>
                                                        <img src={`${URL_S3}image/digital_prop/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                        <span className="remove-props" onClick={removeProps.bind(this, index)}>
                                                            <IoTrashSharp />
                                                        </span>
                                                    </div>
                                                ))

                                                :
                                                <div className="prop__no__item">
                                                    <h4>No Props Selected.</h4>
                                                </div>
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }
                            {
                                loading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default DigitalSetting
